import { useNavigate } from "react-router";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { useFeature } from "@/lib/use-feature";
import { usePermissao } from "@/lib/use-permissao";
import { useConfiguracaoDePacientes } from "@/lib/use-configuracao-de-pacientes";

/**
 * "Lembrar ao agendar" (Configurações › Pacientes): depois de marcar a consulta, se o paciente não
 * tem anamnese ou a dele venceu, oferece ir enviar. Só avisa — a consulta já está marcada.
 */
export function useLembreteDeAnamnese() {
  const navigate = useNavigate();
  const utils = trpc.useUtils();
  const ligada = useFeature("patient.anamnese");
  const podeEnviar = usePermissao("patients.manage");
  const { lembrarAoAgendar } = useConfiguracaoDePacientes().anamnese;

  return async (patientId: string | null | undefined, nome: string) => {
    if (!patientId || !ligada || !podeEnviar || !lembrarAoAgendar) return;
    const r = await utils.anamnese.situacao.fetch({ patientIds: [patientId] }).catch(() => null);
    const s = r?.porPaciente[patientId];
    if (s !== "sem" && s !== "vencida") return;
    toast(s === "sem" ? `${nome} ainda não tem anamnese` : `A anamnese de ${nome} venceu`, {
      description: "Envie o link para o paciente responder antes da consulta.",
      duration: 12_000,
      action: { label: "Enviar anamnese", onClick: () => navigate(`/pacientes/${patientId}?aba=anamnese`) },
    });
  };
}
